import { useState, useCallback, useEffect } from 'react';
import { SelectItemProps, Response } from '@ui/src';
import { useLazyGetTransactionsAccountsQuery } from '../../store/dictionaries/services';
import { Account } from '../../types/account';

interface ListResponse {
  data: Response<Account>;
}

let timeout: NodeJS.Timeout;

const useGetAccountsAutocompleteList = (
  query?: string,
  transactionId?: string,
) => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );
  const [accountsList, setAccountsList] = useState<Account[]>([]);

  const [getList, { isFetching, isLoading }] =
    useLazyGetTransactionsAccountsQuery();

  const getAutocompleteListAction = useCallback(
    async (search?: string, searchQuery?: string) => {
      const results: SelectItemProps[] = [];
      const accounts: Account[] = [];

      const response = (await getList(
        `?take=40&sortProp=fullNumber&sortDir=asc${
          search ? `&search=${search}` : ''
        }${query || ''}${searchQuery || ''}`,
      )) as ListResponse;

      if (response?.data?.data) {
        response.data.data.edges?.forEach((item) => {
          results.push({
            name: item.node.description,
            description: '',
            value: item.node.id,
            suffix: item.node.fullNumber,
          });

          accounts.push(item.node);
        });
      }

      setAutocompleteList(results);
      setAccountsList(accounts);
    },
    [query],
  );

  const onSearch = (search: string) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      getAutocompleteListAction(search);
    }, 300);
  };

  const onClear = () => {
    getAutocompleteListAction('');
  };

  useEffect(() => {
    if (!transactionId) {
      getAutocompleteListAction();
    }
  }, [transactionId]);

  return {
    getAutocompleteListAction,
    autocompleteList,
    onSearch,
    isLoading: isLoading || isFetching,
    accountsList,
    onClear,
    setAutocompleteList,
    setAccountsList,
  };
};

export default useGetAccountsAutocompleteList;
